import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.autogrow();
  }

  autogrow() {
    this.element.style.height = "auto";

    if (this.tooHiddenToMeasure) return;

    this.element.style.height = `${this.element.scrollHeight + this.borderHeight}px`;
  }

  get borderHeight() {
    return this.element.offsetHeight - this.element.clientHeight;
  }

  get tooHiddenToMeasure() {
    return this.element.scrollHeight === 0;
  }
}
